import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  SELECT_DEFAULT_INFO_MDB,
  selectDefaultInfoMDB
} from '../../../actions';
import { createLoadingSelector } from '../../../api/selectors';
import CustomSpinner from '../../../commonComponents/CustomSpinner';
import '../../../themes/global.scss';
import '../../../themes/home.scss';
import ProgressBar from './ProgressBar';

import BackButton from '../../../commonComponents/BackButton';
import Button from '../../../commonComponents/Button';
import { Colors } from '../../../themes/colors';
import EditShiftMDB from './EditShiftMDB';
import Form from './Form';
import { getProfessionCode, getProfessionName } from './utils';

export default ({ history }) => {
  const editedDate = history.location?.state?.editedDate || '';

  const currentJob = useSelector(
    (state) => state.multiday.jobInfo.filter((job) => job.localDate === editedDate)[0],
  );

  const initialBreak = currentJob?.break_time === 0 ? '00' : currentJob?.break_time;
  const allProfessions = useSelector((state) => state.user.allProfessions);
  const [formValues, setFormValues] = useState({
    offerStartTime: currentJob?.localStart || null,
    offerEndTime: currentJob?.localEnd || null,
    rate: currentJob?.rate || 0,
    lunch: initialBreak || null,
    isLunchPaid: currentJob?.is_break_paid || false,
    professionType: getProfessionName(allProfessions, currentJob?.profession),
    skills: currentJob?.skills || 'skill-general',
    enableAutoFill: currentJob?.autoFill || false,
  });
  const loadingSelector = createLoadingSelector([SELECT_DEFAULT_INFO_MDB]);
  const isLoading = useSelector((state) => loadingSelector(state));
  const dispatch = useDispatch();

  const isDisabled = !formValues.offerStartTime || !formValues.offerEndTime || formValues.rate === 0 || !formValues.lunch;

  const nexBtnClicked = () => {
    const selectedProfession = getProfessionCode(allProfessions, formValues.professionType);
    const defaultSkills = selectedProfession === 'DA' ? 'skill-da-general' : 'skill-general';

    const jobData = {
      localStart: formValues.offerStartTime,
      localEnd: formValues.offerEndTime,
      rate: parseFloat(formValues.rate),
      is_break_paid: formValues.isLunchPaid,
      break_time: parseInt(formValues.lunch),
      profession: selectedProfession,
      skills: formValues.skills || defaultSkills,
      autoFill: formValues.enableAutoFill,
    };

    dispatch(selectDefaultInfoMDB({ jobData }));
  };

  if (isLoading) {
    return (
      <div
        className="component_container"
      >
        <div className="floating_container">
          <CustomSpinner isLoading={isLoading} />
        </div>
      </div>
    );
  }

  if (editedDate && currentJob) {
    return <EditShiftMDB currentJob={currentJob} />;
  }

  return (
    <div className="component_container">
      <div
        className="floating_container"
        style={{ justifyContent: 'flex-start', flexDirection: 'column' }}
      >
        <div className="card">
          <div style={{ marginTop: 20, marginLeft: 30 }}>
            <BackButton />
          </div>
          <div className="card-body" style={{ margin: 30 }}>
            <ProgressBar step={2} />

            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: '100%',
              }}
            >
              <h3
                style={{
                  fontFamily: 'Nunito',
                  color: Colors.neutral_500,
                  textAlign: 'center',
                  fontSize: 16,
                  fontStyle: 'italic',
                  marginTop: 55,
                  fontWeight: 400,
                  justifyContent: 'center'
                }}
              >
                Note: You will be able to edit the details of individual shifts in the next step.
              </h3>

              <Form formValues={formValues} setFormValues={setFormValues} />
            </div>
          </div>
        </div>
        <div
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 120,
            marginTop: 20,
          }}
        >
          <Button
            text="Next"
            onClick={() => nexBtnClicked()}
            disabled={isDisabled}
          />
        </div>
      </div>
    </div>
  );
};
